import { render, staticRenderFns } from "./SlackChannelSelector.vue?vue&type=template&id=208f323c"
import script from "./SlackChannelSelector.vue?vue&type=script&lang=ts"
export * from "./SlackChannelSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports